import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { postCustomerMaster, getCustomerMaster } from '../store/actions/dispatchOrderDetailsActions'
import { Link } from "react-router-dom";
import Modal from '../Components/CustomModal'
import ModalHeader from '../Components/ModalHeader'
import ModalBody from '../Components/ModalBody'
import ModalFooter from '../Components/ModalFooter'
import AuthHandlerInstance from '../Classes/AuthHandler'
import toast from 'react-hot-toast';
import dateFormater from '../Classes/FormatDateTimeInIST';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import swal from 'sweetalert';
import Select from 'react-select';

class DispatchAddTemplate extends Component {
    constructor() {
        super()
        this.state = {
            show: false,
            CustomerName: '',
            CustomerAddress: '',
            CustomerGst: '',
            addDocumentmodal: false,
            tableData: [],
            dispatchTemplateId: 0,
            dropdownarray: [],
            projectNo: "",
            dropdownarray1: [],
            peojectCodeValueDropDwon: {},
            userId: AuthHandlerInstance.getUserID(),
        }
    }
    componentDidMount() {
        this.dataSync()
    }
    dataSync = async () => {
        let tableData = []
        await this.props.getCustomerMaster()
        console.log(await this.props.dispatchOrderDetailsReducer, "ljhgfdwerto")
        tableData = await this.props.dispatchOrderDetailsReducer.getCustomerMaster
        if (tableData.length > 0) {
            await this.setState({ tableData })
        }

    }

    addDocumentmodal(indicator) {
        console.log("khgwdvsaz", indicator, this.state.tableData)
        this.setState({ addDocumentmodal: !this.state.addDocumentmodal, indicator });
        if (this.state.addDocumentmodal == true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2" }
            )
        }
    }
    deletetemplatemodal(dispatchTemplateId) {
        this.setState({ deletetemplatemodal: !this.state.deletetemplatemodal });
        if (this.state.deletetemplatemodal == true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2", dispatchTemplateId }
            )
        }
    }
    handleCustomer = (event) => {
        const { name, value } = event.target
        console.log(name, value);
        this.setState({
            ...this.state,
            [name]: value
        });
    }
    addTemplate = async () => {
        if (this.state.CustomerName == '') {
            swal("Kindly Input a Valid Name", { icon: "error" })
            return false;
        }
        if (this.state.CustomerAddress == '') {
            swal("Kindly Input a Valid Name", { icon: "error" })
            return false;
        }
        if (this.state.CustomerGst == '') {
            swal("Kindly Input a Valid Name", { icon: "error" })
            return false;
        }
        let input = {
            CustomerName: this.state.CustomerName,
            CustomerAddress: this.state.CustomerAddress,
            GSTIN: this.state.CustomerGst,
            userId: this.state.userId,
            indicator: 0, //for Insert
            CustomerId: 0, //for Insert
        }
        let isCustomerPresent = this.state.tableData.find(customer => customer.CustomerName === this.state.CustomerName)
        if (isCustomerPresent) {
            swal("Customer Already Exists", { icon: "error" })
            return false;
        }
        await this.props.postCustomerMaster(input)
        await toast.success(`${this.state.CustomerName} has been added`, {
            duration: 4000
        });
        await this.addDocumentmodal()
        await this.dataSync()
    }
    handleTemplateName = (e, Index) => {
        let input = e.target.value
        let tableData = [...this.state.tableData]
        tableData[Index].TemplateName = input
        this.setState({ tableData })
    }
    handleDelete = async (data) => {
        let input = {
            indicator: 1,
            CustomerId: data
        }
        await this.props.postCustomerMaster(input)
        await this.deletetemplatemodal()
        await this.dataSync()
        await toast.success(`Successfully Deleted`, {
            duration: 3000
        });
    }


    // handleDelete = async (data) => {
    //     let input = {
    //         indicator:1,
    //         CustomerId: this.state.userId
    //     }
    //     await this.props.postCustomerMaster(input)
    //     await this.deletetemplatemodal()
    //     await this.dataSync()
    //     await toast.success(`Successfully Deleted`, {
    //         duration: 3000
    //     });
    // }
    render() {
        return (
            <div className="container">
                {/* Add Document MODAL starts */}
                <Modal isOpen={this.state.addDocumentmodal} >
                    <div className={"modal-bg" + (this.state.addDocumentmodal === 'false' ? 'open' : '')}>
                        <div className="modalheads">
                            <ModalHeader HeaderStyle="modal-header">
                                <div><h4 >Add Customer </h4></div>
                                <button type="button" className="close" aria-label="Close" onClick={(e) => this.addDocumentmodal(e)} >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </ModalHeader>
                        </div>
                        <div >
                            <ModalBody Style="modal-body">
                                <div className="row ml-2 pt-2">
                                    <div className="col-md-5"><b>Customer Name :</b></div>
                                    <div className="col-md-7">
                                        <input type="text" className="form-control" name='CustomerName' value={this.state.CustomerName} onChange={(e) => this.handleCustomer(e)}></input>
                                    </div>
                                </div>
                                <div className="row ml-2 pt-2">
                                    <div className="col-md-5"><b>Customer Address :</b></div>
                                    <div className="col-md-7">
                                        <textarea type="text" className="form-control" name='CustomerAddress' value={this.state.CustomerAddress} onChange={(e) => this.handleCustomer(e)}></textarea>
                                    </div>
                                </div>
                                <div className="row ml-2 pt-2">
                                    <div className="col-md-5"><b>Customer GST :</b></div>
                                    <div className="col-md-7">
                                        <input type="text" className="form-control" name='CustomerGst' value={this.state.CustomerGst} onChange={(e) => this.handleCustomer(e)}></input>
                                    </div>
                                </div>
                            </ModalBody>
                        </div>
                        <div>
                            <ModalFooter FooterStyle="modal-footer">
                                <div>
                                    <button className="btn2 btn-sms1 rounded-pill mt-2 ml-4 float-right" onClick={() => this.addDocumentmodal()} type="submit">Cancel</button>
                                    <button className="btn2 btn-sms1 rounded-pill mt-2 ml-4 float-right" onClick={() => this.addTemplate()} type="submit">Add Customer</button>
                                </div>
                            </ModalFooter>
                        </div>
                    </div>
                </Modal>
                {/* Add Document MODAL ENDS */}
                {/* WANT TO DELETE TEMPLATE MODAL starts */}
                <Modal isOpen={this.state.deletetemplatemodal} >
                    <div className={"modal-bg" + (this.state.deletetemplatemodal === 'false' ? 'open' : '')}>
                        <div className="modalheads">
                            <ModalHeader HeaderStyle="modal-header">
                                <div><h4 >Delete Customer </h4></div>
                                <button type="button" className="close" aria-label="Close" onClick={(e) => this.deletetemplatemodal(e)} >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </ModalHeader>
                        </div>
                        <div >
                            <ModalBody Style="modal-body">
                                <div className="row ml-2 pt-2">
                                    <div className="col-md-10"><b>Are You Sure To Delete ?</b></div>
                                </div>
                            </ModalBody>
                        </div>
                        <div>
                            <ModalFooter FooterStyle="modal-footer">
                                <div>
                                    <button className=" btn2 btn-sms1 rounded-pill mt-2 ml-4 float-right" onClick={() => this.deletetemplatemodal()} type="submit">NO</button>
                                    <button className="btn2 btn-sms1 rounded-pill mt-2 ml-4 float-right" onClick={() => this.handleDelete(this.state.dispatchTemplateId)} type="submit">YES</button>
                                </div>
                            </ModalFooter>
                        </div>
                    </div>
                </Modal>
                <div className="w-100 mx-auto shadow p-5" style={{ marginTop: "1%" }}>
                    <form onSubmit={this.handleSubmit}>
                        <div className="row mb-4">
                            <div className="col-md-2">
                                <h5>Add Customer</h5>
                            </div>
                            <div className="col-md-4">
                                <i className="fas fa-plus-circle fa-lg" onClick={() => this.addDocumentmodal()} style={{ cursor: 'pointer', backgroundColor: 'white', color: 'blue' }}></i>
                            </div>
                        </div>
                        <table className="table1" style={{width: '-webkit-fill-available'}}>
                            <thead className="thead" style={{ backgroundColor: "#0989CB" }}>
                                <tr>
                                    <th scope="col">Name</th>
                                    <th scope="col">Address</th>
                                    <th scope="col">GSTIN</th>
                                    <th scope="col">Created On</th>
                                    <th scope="col">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.tableData.map((item, Index) =>
                                    <tr>
                                        <td>{item.CustomerName}</td>
                                        <td>{item.CustomerAddress}</td>
                                        <td>{item.GSTIN}</td>
                                        <td>{item.CreatedOn}<br/><span className='badge badge-primary'>By {item.UserName}</span></td>
                                        <td style={{ textAlign: "center" }}>
                                            <FontAwesomeIcon className="ml-2" icon={"trash-alt"} color="red" title="Delete" cursor="pointer" onClick={() => this.deletetemplatemodal(item.CustomerId)} />
                                        </td>
                                    </tr>
                                )
                                }
                            </tbody>
                        </table>
                    </form>
                </div>
            </div>
        )
    }
}


const mapStateToProps = (state) => ({ dispatchOrderDetailsReducer: state.dispatchOrderDetailsReducer })
export default connect(mapStateToProps, { postCustomerMaster, getCustomerMaster })(DispatchAddTemplate)
